<template>
  <div>
    <div>
      <section style="margin-left: 12px; margin-bottom: 10px; margin-top: 20px;">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <h1 class="title is-4 has-text-weight-medium">
                <b-icon icon="notebook-outline"/> &nbsp; Pembayaran <br/>
                <h2 style="margin-top: 10px;" class="subtitle is-5 tag">Saldo Rp. 12.000.000</h2>
              </h1>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <top-up></top-up>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="level" style="border-bottom: solid thin #f0f0f0; margin-bottom: 0px;">
      <div class="level-left">
        <div class="tab-label active">
          Jurnal
        </div>
        <div class="tab-label">
          Pending Top Up
        </div>
      </div>
      <div class="level-right" style="padding-right: 20px;">
        <div>
          <b-field>
            <b-select placeholder="Cari Cabang">
              <option
                  v-for="option in cabang"
                  :value="option.id"
                  :key="option.id">
                  {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div style="width: 300px; margin-left: 10px;">
          <b-field>
            <b-input placeholder="Cari Customer..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="searchOnClick">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>

    <div>
      <b-table paginated per-page="10" :data="jurnal" scrollable>
        <b-table-column field="project_name" label="Transaksi" v-slot="props">
          {{ props.row.project_name }} <br/>
          <span class="tag">{{ props.row.type }}</span>
          {{ props.row.customer_name }}
        </b-table-column>
        <b-table-column field="timestamp" label="Timestamp" v-slot="props">
          {{ props.row.timestamp }}
        </b-table-column>
        <b-table-column field="beginning_balance" label="Saldo Awal" v-slot="props">
          {{ props.row.beginning_balance }}
        </b-table-column>
        <b-table-column field="mutation" label="Mutasi" v-slot="props">
          {{ props.row.mutation }}
        </b-table-column>
        <b-table-column field="ending_balance" label="Saldo Akhir" v-slot="props">
          {{ props.row.ending_balance }}
        </b-table-column>
        <b-table-column field="pic" label="Penanggung Jawab" v-slot="props">
          {{ props.row.pic }}
        </b-table-column>
        <b-table-column field="branch" label="Cabang" v-slot="props">
          {{ props.row.branch }}
        </b-table-column>
        <b-table-column field="noted" label="Catatan" v-slot="props">
          {{ props.row.noted }}
        </b-table-column>
      </b-table>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import TopUp from './TopUp.vue'
import pembayaran from '../../api/pembayaran'
import { mapGetters } from 'vuex'

export default {
  name: 'PembayaranList',
  computed: {
    ...mapGetters('pembayaran', {
      jurnal: 'getJurnal'
    })
  },
  components: {
    TopUp
  },
  methods: {
    searchOnClick () {

    },
    setFormat (v) {
      return moment(v).format('DD MMMM YYYY')
    }
  },
  data () {
    return {
      topUpNav: 0,
      cabang: [
        { id: 1, name: 'ACE Aeon Mall' },
        { id: 2, name: 'ACE Mall Serpong' },
        { id: 3, name: 'ACE BTC Tangerang Selatan' }
      ]
    }
  },
  mounted () {
    pembayaran.getJurnal((val) => {
      this.$store.commit('pembayaran/setJurnal', val)
    })
  }
}
</script>

<style lang="scss" scoped>
.dash-container {
  padding: 20px 0px 0px 0px;
}
.card-kanggo {
  background-color: white;
  margin: 0px 10px 10px 10px;
  border-radius: 5px;
  padding: 5px 0px 5px 0px;
  font-size: 14px;
  table {
    tr {
      td {
        width: auto;
        border-bottom: solid thin rgb(240, 240, 240);
        height: 45px;
        padding: 10px 15px 5px 15px;
      }
    }
  }
}
.card-paginate {
  display: flex;
  font-size: 14px;
}
.tab-label {
  width: 150px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  cursor: pointer;
  &.active {
    border-bottom: solid thin red;
    color: red;
    font-weight: bold;
  }
}
</style>
